'use client';

import { FC } from 'react';
import { FooterColumnStoryblok } from 'storyblok-types';
import { Body } from 'atoms/Typography/Typography';
import { Accordion } from 'molecules/Accordion';
import { gtmPushFooterNavigation } from 'modules/gtm/modules/sections/navigation/navigation';
import { useMediaQuery } from 'modules/mui/hooks';
import { Item } from './Item';
import styles from './styles.module.css';

export const Column: FC<{ column: FooterColumnStoryblok }> = ({ column }) => {
  const { isMobile } = useMediaQuery();

  const handleLinkClick = (
    columnTitle: string | undefined,
    itemTitle: string,
  ) => {
    gtmPushFooterNavigation(columnTitle, itemTitle);
  };

  return (
    <Accordion
      summaryContent={
        <Body type="md" tag="span" className={styles.title}>
          {column.title}
        </Body>
      }
      classes={{
        summaryRoot: styles.accordionSummaryRoot,
        bareRoot: styles.accordionRoot,
      }}
      disabled={!isMobile}
      defaultExpanded={!isMobile}
    >
      <ul className={styles.list}>
        {column?.rows?.map((item) => (
          <li key={item._uid} className={styles.item}>
            <Item
              {...item}
              onClick={() =>
                handleLinkClick(column.title, item?.text as string)
              }
            />
          </li>
        ))}
      </ul>
    </Accordion>
  );
};
